import type { BudgetTypes } from 'src/App/pages/ad-budget-selection/mapBudgetOption';

import type { AdBudgetType, PricingModel } from '../../generated/graphql-types';
import type { AdvertiserContract } from '../../types/advertiser';

const mapAdvertiserContracts = (
  advertiserContracts: AdvertiserContract[],
): string => {
  const isVariablePriceContract = (contract: AdvertiserContract) =>
    contract.contractType === 'SEEK_CONTRACT';
  const isFixedPriceContract = (contract: AdvertiserContract) =>
    contract.contractType === 'AD_PACK' ||
    contract.contractType === 'MASTER_AGREEMENT' ||
    contract.contractType === 'SUBSCRIPTION';

  if (advertiserContracts.some(isVariablePriceContract)) {
    return 'contract';
  } else if (advertiserContracts.some(isFixedPriceContract)) {
    return 'ad-pack';
  }
  return 'casual';
};

const mapAdBudgetTypeToTrackingBudgetType = (
  adBudgetType: AdBudgetType,
): BudgetTypes => {
  if (adBudgetType === 'CLASSIC_ONWARDS') {
    return 'FlexibleBudget';
  }
  if (adBudgetType === 'BRANDED_ONWARDS') {
    return 'BrandedBudget';
  }
  if (adBudgetType === 'PREMIUM_ONLY') {
    return 'PremiumBudget';
  }

  throw new Error(`unexpected budgetType: ${adBudgetType}`);
};

const mapAdBudgetType = (adBudgetType: AdBudgetType): string => {
  if (adBudgetType === 'CLASSIC_ONWARDS') {
    return 'contractClassic';
  }
  if (adBudgetType === 'BRANDED_ONWARDS') {
    return 'contractStandout';
  }
  if (adBudgetType === 'PREMIUM_ONLY') {
    return 'contractPremium';
  }

  throw new Error(`unexpected budgetType: ${adBudgetType}`);
};

const mapLegacyAdBudgetType = (adBudgetType: string): string => {
  if (adBudgetType === 'FlexibleBudget') {
    return 'contractClassic';
  }
  if (adBudgetType === 'BrandedBudget') {
    return 'contractStandout';
  }
  if (adBudgetType === 'PremiumBudget') {
    return 'contractPremium';
  }
  throw new Error(`unexpected budgetType: ${adBudgetType}`);
};

const mapPricingModel = (pricingModel: PricingModel): string => {
  switch (pricingModel) {
    case 'FIXED':
      return 'fixed';
    case 'HORIZON':
      return 'variable';
  }
};

export {
  mapAdvertiserContracts,
  mapAdBudgetType,
  mapLegacyAdBudgetType,
  mapPricingModel,
  mapAdBudgetTypeToTrackingBudgetType,
};
